import { AnchorLinkWidget } from '~components/generic/elements/AnchorLinkSelector/AnchorLinkWidget';
import entityContainerConnector from '~components/generic/entityContainerConnector';

export default entityContainerConnector(AnchorLinkWidget);
